const brPriceTable = {
  priceTable: {
    label: {
      name: 'Name',
      vendor: 'Vendor',
      category: 'Category',
      description: 'Description',
      preset: 'Is preset',
      createdAt: 'Created at',
      document: 'Doc:',
      seeTablePrice: 'See price table',
    },

    table: {
      title: 'Price table',
      name: 'Name',
      item: 'Item',
      category: 'Category',
      basePrice: 'Base price',
      comboPrice: 'Combo price',
      description: 'Description',
    },

    action: {
      cancel: 'Cancel',
      edit: 'Edit price table',
      create: 'Create price table',
      delete: 'Delete price table',
      loading: 'Loading price table',
    },

    hints: {
      delete: 'Do you really want to delete this item?',
    },

    messages: {
      successfullyCreated: 'Item created successfully',
      successfullyUpdated: 'Item updated successfully',
      successfullyEdited: 'Item edited successfully',
      successfullyDeleted: 'Item removed successfully',
    },
  },
};

export default brPriceTable;
